var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.myList.length)?_c('NetflixRow',{staticClass:"mylist",attrs:{"data":_vm.myList,"title":"My List"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }